import React from 'react';
import Navbar from './navbar';
import { Redirect, Link } from 'react-router-dom';
import MultiColorProgressBarLegend from './multiColorProgressBarLegend';
import { Checkbox, Table, Button, Form, Radio, Input, Popup, Icon, Dropdown } from 'semantic-ui-react';

import hocify from 'hocify';
import containerStyle from '../jss/containers';

const withStyles = hocify(containerStyle);

class ShippingMethod extends React.Component {


    constructor(properties) {
        super(properties);

        //set form values
        this.state = {
            productID: '',
            requestAll: true,
            QueryData: null,
            Processes: null,
            typeChoice: 1,
            flag: " ASC"
        };

        this.processEvtSource = new EventSource(process.env.REACT_APP_SERVER_ROOT + "/process/sseRead.php");

        this.handleChange = this.handleChange.bind(this);
        this.getProducts = this.getProducts.bind(this);
        this.setTypeChoice = this.setTypeChoice.bind(this);
        this.setTypeChoice = (e, { value }) => this.setState({ value })
        this.setShip = this.setShip.bind(this);
        this.appendProductNotes = this.appendProductNotes.bind(this);
        this.abortController = new AbortController();
    }

    handleChange(event) {
        //update the value for which ever field was changed
        /*  if(event.target.id === "productID"){
              this.setState({productID: event.target.value});
          }else if(event.target.id === "requestAll"){
              this.setState({requestAll: event.target.checked});
          }*/

        if (event.target.value !== "") {
            this.setState({ requestAll: false });
        }
        else {
            this.setState({ requestAll: true });
        }
        this.setState({ productID: event.target.value }, this.getProducts);

    }

    //get the product data from the db
    async getProducts(sortby) {

        //encode the token, productID if not requesting all products, or if all products are being requested
        let productJSON = JSON.stringify({
            flagAD: this.state.flag,
            orderby: sortby,
            token: sessionStorage.getItem("token"),
            jobRole: sessionStorage.getItem("jobRole"),
            requestAll: this.state.requestAll,
            productID: this.state.productID
        });
        if (this.state.flag == " ASC") {
            this.state.flag = " DESC";
        }
        else {
            this.state.flag = " ASC";
        }

        try {
            //send the request data to the product stat read page
            const requestPath = process.env.REACT_APP_SERVER_ROOT + "analytics/productStatistics/read.php";
            let response = await fetch(requestPath, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: productJSON,
                signal: this.abortController.signal
            });

            //process the response
            let responseJSON = await response.json();
            if (responseJSON['status'] === 200) {
                //remove the status element from the returned json, to allow eaiser process of the data
                delete responseJSON['status'];
                //store the product data in the state
                this.setState({
                    QueryData: responseJSON
                });

            } else {
                alert("Could not get product(s)");
            }

        } catch (error) {
            if (error.name === 'AbortError') {
            }
        }
    }

    async appendProductNotes(productID, notes) {
        let productJSON = JSON.stringify({
            productID: productID,
            token: sessionStorage.getItem("token"),
            jobRole: sessionStorage.getItem("jobRole"),
            notes: notes
        });
        try {

            let response = await fetch(process.env.REACT_APP_SERVER_ROOT + "product/shippingDescription.php", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: productJSON,
                signal: this.abortController.signal
            });

            let responseJson = await response.json();
        } catch (error) {
            if (error.name === 'AbortError') {
            }
        }
    }

    setShip(productID, shipper) {
        //console.log("test");
        let notes = "(" + shipper + ")";
        //console.log(productID + " " + notes);
        this.appendProductNotes(productID, notes);
    }

    componentDidMount() {
        //send all onmessage events to the sse receive method
        this.processEvtSource.onmessage = e => this.receiveProcessData(e);

        this.getProducts("productID");
    }

    componentWillUnmount() {
        this.processEvtSource.close();
        this.abortController.abort();
    }

    receiveProcessData(e) {
        let message = JSON.parse(e.data);

        if (message["status"] === 200) {
            delete message["status"];

            if (JSON.stringify(message) !== JSON.stringify(this.state.Processes)) {
                this.setState({ Processes: message });
            }
        }
    }

    setTypeChoice(event) {
        this.setState(this.state.typeChoice = event.target.value);
    }

    //renders everything for controlling the page
    renderControls() {

        if (this.state.QueryData === null || this.state.Processes === null) {
            return (<div><Navbar selectedPage="shippingMethod" /></div>);
        }

        return (<div>
            <Navbar selectedPage="shippingMethod" />
        </div>);
    }



    renderProducts() {

        if (this.state.QueryData === null || this.state.Processes === null) {
            return (<div></div>);
        }

        //console.log(this.state.typeChoice);

        const products = [];
        //add each product from the db to the table
        for (let index = 0; index < Object.keys(this.state.QueryData).length; index++) {
            let value = this.state.QueryData[index];

            let processStages = null;

            let processID = value["Process"];

            //get stages
            let stageIDs = this.state.Processes[processID].stageIDs

            processStages = "";
            for (let i = 0; i < Object.keys(stageIDs).length; i++) {
                processStages += stageIDs[i + 1];

                if (i !== Object.keys(stageIDs).length - 1) {
                    processStages += ", ";
                }
            }
            let bgColor = 'black';
            var today = new Date();
            var dd = String(today.getDate()).padStart(2, '0');
            var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yyyy = today.getFullYear();

            today = yyyy + '-' + mm + '-' + dd;
            let desc = value["Notes"];

            //Only show cutting tools
            if (this.state.typeChoice == "UPS" && value.Notes.includes('(UPS)')) {
                products.push(<Table.Row key={index}>
                    <Table.Cell>{value["ProductID"]}</Table.Cell>
                    <Table.Cell>{value["Customer"]}</Table.Cell>
                    <Table.Cell>{value["ProductName"]}</Table.Cell>
                    <Table.Cell>{value["Quantity"]}</Table.Cell>
                    <Table.Cell>{value["ProductWeight"]}</Table.Cell>
                    <Table.Cell>{value["ShipmentSchedule"]}</Table.Cell>
                    <Table.Cell>{value["PONumber"]}</Table.Cell>
                    <Table.Cell>{value["Coating"]}</Table.Cell>
                    <Table.Cell>{value["Notes"]}</Table.Cell>
                </Table.Row>);
            }
            else if (this.state.typeChoice == "Fedex" && value.Notes.includes('(FEDEX)')) {
                products.push(<Table.Row key={index}>
                    <Table.Cell>{value["ProductID"]}</Table.Cell>
                    <Table.Cell>{value["Customer"]}</Table.Cell>
                    <Table.Cell>{value["ProductName"]}</Table.Cell>
                    <Table.Cell>{value["Quantity"]}</Table.Cell>
                    <Table.Cell>{value["ProductWeight"]}</Table.Cell>
                    <Table.Cell>{value["ShipmentSchedule"]}</Table.Cell>
                    <Table.Cell>{value["PONumber"]}</Table.Cell>
                    <Table.Cell>{value["Coating"]}</Table.Cell>
                    <Table.Cell>{value["Notes"]}</Table.Cell>
                </Table.Row>);
            }
            else if (this.state.typeChoice == "Seavac" && value.Notes.includes('SEAVAC')) {
                products.push(<Table.Row key={index}>
                    <Table.Cell>{value["ProductID"]}</Table.Cell>
                    <Table.Cell>{value["Customer"]}</Table.Cell>
                    <Table.Cell>{value["ProductName"]}</Table.Cell>
                    <Table.Cell>{value["Quantity"]}</Table.Cell>
                    <Table.Cell>{value["ProductWeight"]}</Table.Cell>
                    <Table.Cell>{value["ShipmentSchedule"]}</Table.Cell>
                    <Table.Cell>{value["PONumber"]}</Table.Cell>
                    <Table.Cell>{value["Coating"]}</Table.Cell>
                    <Table.Cell>{value["Notes"]}</Table.Cell>
                </Table.Row>);
            }
            else if (this.state.typeChoice != "Seavac" && this.state.typeChoice != "UPS" && this.state.typeChoice != "Fedex") {
                products.push(<Table.Row key={index}>
                    <Table.Cell>{value["ProductID"]}</Table.Cell>
                    <Table.Cell>{value["Customer"]}</Table.Cell>
                    <Table.Cell>{value["ProductName"]}</Table.Cell>
                    <Table.Cell>{value["Quantity"]}</Table.Cell>
                    <Table.Cell>{value["ProductWeight"]}</Table.Cell>
                    <Table.Cell>{value["ShipmentSchedule"]}</Table.Cell>
                    <Table.Cell>{value["PONumber"]}</Table.Cell>
                    <Table.Cell>{value["Coating"]}</Table.Cell>
                    <Table.Cell>{value["Notes"]}</Table.Cell>
                </Table.Row>);
            }
        }

        return (products);
    }


    render() {

        const ddChoices = [];
        var choiceOBJ = {};

        if (this.state.QueryData != null) {

            for (let index = 0; index < Object.keys(this.state.QueryData).length; index++) {
                let val = this.state.QueryData[index];
                //console.log(val.ProductID);
                choiceOBJ = { key: val["ProductID"], text: val["ProductID"], value: val["ProductID"] }
                ddChoices.push(choiceOBJ);
            }
        }
        //console.log(ddChoices);

        //if the token is not present, the user is not signed in send them to signin
        if (sessionStorage.getItem("token") === null || sessionStorage.getItem("jobRole") === null) {
            return (<Redirect to="/signin" />);
        }
        var job = sessionStorage.getItem("jobRole");
        if (job !== 'Manager' && job !== 'Employee') {
            return (<Redirect to="/signin" />);
        }

        return (<div>

            {this.renderControls()}

            <div className={this.props.container + " " + "blueBackground"}>
                <div>
                    <Dropdown placeholder='Product ID' id="pidForm" selection clearable search options={ddChoices}></Dropdown>
                    {"\u00A0"}<Button className="smallBtn2" onClick={() => { this.setShip(document.querySelector("#pidForm > div.text").innerHTML, "UPS"); window.location.reload(true); }}>
                        Ship UPS</Button>
                    {"\u00A0"}<Button className="smallBtn2" onClick={() => { this.setShip(document.querySelector("#pidForm > div.text").innerHTML, "FEDEX"); window.location.reload(true); }}>
                        Ship FedEx</Button>
                    {"\u00A0"}<Button className="smallBtn2" onClick={() => { this.setShip(document.querySelector("#pidForm > div.text").innerHTML, "SEAVAC - Joe"); window.location.reload(true); }}>
                        Ship Seavac - Joe</Button>
                    {"\u00A0"}<Button className="smallBtn2" onClick={() => { this.setShip(document.querySelector("#pidForm > div.text").innerHTML, "SEAVAC - Toida"); window.location.reload(true); }}>
                        Ship Seavac - Toida</Button>
                    {"\u00A0"}<Button className="smallBtn2" onClick={() => { this.setShip(document.querySelector("#pidForm > div.text").innerHTML, "SEAVAC - Imoto"); window.location.reload(true); }}>
                        Ship Seavac - Imoto</Button></div>

                <Form>
                    <Form.Field>
                        Current filter: <b>{this.state.typeChoice = this.state.value}</b>
                    </Form.Field>
                    <Form.Field>
                        <Radio
                            label='No filter'
                            name='radioGroup'
                            value='none'
                            checked={this.state.value === 'none'}
                            onChange={this.setTypeChoice}
                            defaultChecked
                        />
                        {"\u00A0\u00A0\u00A0\u00A0"}
                        <Radio
                            label='UPS'
                            name='radioGroup'
                            value='UPS'
                            checked={this.state.value === 'UPS'}
                            onChange={this.setTypeChoice}
                        />{"\u00A0\u00A0\u00A0\u00A0"}
                        <Radio
                            label='Fedex'
                            name='radioGroup'
                            value='Fedex'
                            checked={this.state.value === 'Fedex'}
                            onChange={this.setTypeChoice}
                        />{"\u00A0\u00A0\u00A0\u00A0"}
                        <Radio
                            label='Seavac'
                            name='radioGroup'
                            value='Seavac'
                            checked={this.state.value === 'Seavac'}
                            onChange={this.setTypeChoice}
                        />
                    </Form.Field>
                </Form>
                <Table compact celled unstackable>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Product ID</Table.HeaderCell>
                            <Table.HeaderCell>Customer</Table.HeaderCell>
                            <Table.HeaderCell>Product Name</Table.HeaderCell>
                            <Table.HeaderCell>Quantity</Table.HeaderCell>
                            <Table.HeaderCell>Product Weight</Table.HeaderCell>
                            <Table.HeaderCell>Shipment Schedule</Table.HeaderCell>
                            <Table.HeaderCell>PO Number</Table.HeaderCell>
                            <Table.HeaderCell>Coating</Table.HeaderCell>
                            <Table.HeaderCell width={2}>Description</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {this.renderProducts()}
                    </Table.Body>
                </Table>
            </div>
        </div>);
    }

}

export default withStyles(ShippingMethod);
